module.exports = __webpack_public_path__ + "static/img/avatar_dark.30499ba7.svg";